import { BillCategory } from './BillCategory';

export class Invoice {

    private invoiceId: number;
    private billCategoryStr: string;
    private billCategory: string;    
    private billGroup: string; 
    private dateStr: string;
    private date: Date;
    private remarks: string[];
    private invoiceFrom: string;
    private camCode: string;
    private billingCode: string;
    private description: string;
    private roomType: string;
    private quantity: number;
    private tariff: number;
    private rate: number;
    private displayRate: number;
    private discount: number;
    private amount: number;
    private approvedAmount: number;
    private isClaimable: boolean;
    private comments: string[];
    private comment: string;
    private startDate:Date;
    private endDate:Date;
    private roomCategory:string;
    private isGipsa:Boolean;
    private category: string;
    private group: string;
    private type: string;

    private icdRegex:string;
	private pcsRegex:string;
	private icdCode:string[];
    private pcsCode:string[];
    private invoiceNumber:string;    
    private disallowed:number;
    private tariffDeduction: number;
    private totalTariffDeduction: number;
    private applicableAmount: number;


  

    constructor(invoiceDto: any) {

        if (invoiceDto) {

            this.invoiceId = invoiceDto.invoiceId;

            if(invoiceDto.billCategoryStr) {
                this.billCategoryStr = invoiceDto.billCategoryStr;
            }
            if (invoiceDto.billCategory) this.billCategory = invoiceDto.billCategory;
            if (invoiceDto.billGroup) this.billGroup = invoiceDto.billGroup;

            this.dateStr = invoiceDto.dateStr;
            this.invoiceNumber = invoiceDto.invoiceNumber;
            this.disallowed = invoiceDto.disallowed;
            this.tariffDeduction = invoiceDto.tariffDeduction;
            this.totalTariffDeduction = invoiceDto.totalTariffDeduction;
            this.applicableAmount = invoiceDto.applicableAmount;

            
            if (invoiceDto.date) {
                this.date = new Date(invoiceDto.date);
            }
            if (invoiceDto.camCode) {
                this.camCode = invoiceDto.camCode;
            }
            this.invoiceNumber = invoiceDto.invoiceNumber;
            this.isGipsa = invoiceDto.isGipsa;
            this.comment = invoiceDto.comment;
            this.invoiceFrom = invoiceDto.invoiceFrom;
            this.billingCode = invoiceDto.billingCode;
            this.description = invoiceDto.description;
            this.roomType = invoiceDto.roomType;
            this.quantity = invoiceDto.quantity;
            this.tariff = invoiceDto.tariff;
            this.rate = invoiceDto.rate;
            this.displayRate = invoiceDto.displayRate;
            this.discount = invoiceDto.discount;
            this.amount = invoiceDto.amount;
            this.pcsRegex = invoiceDto.pcsRegex;
            this.icdRegex = invoiceDto.icdRegex;
            if(invoiceDto.icdCode)
            {
                this.icdCode = invoiceDto.icdCode;                
            }
            else{
                this.icdCode = [];
            }

            if(invoiceDto.pcsCode)
            {
                this.pcsCode = invoiceDto.pcsCode;
            }
            else
            {
                this.pcsCode=[];
            }
            this.approvedAmount = invoiceDto.approvedAmount;
                this.isClaimable = invoiceDto.isClaimable;
            if (invoiceDto.comments) {
                this.comments = [];
                for (const comment of invoiceDto.comments) {
                    this.comments.push(comment);
                }
            }
            if (invoiceDto.remarks) {
                this.remarks = [];
                for (const comment of invoiceDto.remarks) {
                    this.remarks.push(comment);
                }
            }
            if(invoiceDto.startDate) {
                this.startDate = invoiceDto.startDate;
            }

            if(invoiceDto.endDate) {
                this.endDate = invoiceDto.endDate;
            }

            if(invoiceDto.roomCategory) {
                this.roomCategory = invoiceDto.roomCategory;
            }

            if(invoiceDto.group) {
                this.group = invoiceDto.group;
            }

            if(invoiceDto.category) {
                this.category = invoiceDto.category;
            }

            if(invoiceDto.type) {
                this.type = invoiceDto.type;
            }
        }
    }

    public get $tariffDeduction(): number {
        return this.tariffDeduction;
    }
    public set $tariffDeduction(value: number) {
        this.tariffDeduction = value;
    }

    /**
     * Getter $camCode
     * @return {string}
     */
    public get $camCode(): string {
        return this.camCode;
    }

    /**
     * Setter $camCode
     * @param {string} value
     */
    public set $camCode(value: string) {
        this.camCode = value;
    }
    /**
     * Getter $invoiceNumber
     * @return {string}
     */
    public get $invoiceNumber(): string {
        return this.invoiceNumber;
    }

    /**
     * Setter $invoiceNumber
     * @param {string} value
     */
    public set $invoiceNumber(value: string) {
        this.invoiceNumber = value;
    }
    /**
     * Getter $isGipsa
     * @return {any}
     */
    public get $isGipsa(): any {
        return this.isGipsa;
    }

    /**
     * Setter $isGipsa
     * @param {any} value
     */
    public set $isGipsa(value: any) {
        this.isGipsa = value;
    }
    
    /**
     * Getter $startDate
     * @return {any}
     */
    public get $startDate(): any {
        return this.startDate;
    }

    /**
     * Setter $startDate
     * @param {any} value
     */
    public set $startDate(value: any) {
        this.startDate = value;
    }

    /**
     * Getter $endDate
     * @return {any}
     */
    public get $endDate(): any {
        return this.endDate;
    }

    /**
     * Setter $endDate
     * @param {any} value
     */
    public set $endDate(value: any) {
        this.endDate = value;
    }

     /**
     * Getter $roomCategory
     * @return {any}
     */
    public get $roomCategory(): any {
        return this.roomCategory;
    }

    /**
     * Setter $roomCategory
     * @param {any} value
     */
    public set $roomCategory(value: any) {
        this.roomCategory = value;
    }


    /**
     * Getter $comment
     * @return {string}
     */
    public get $comment(): string {
        return this.comment;
    }

    /**
     * Setter $comment
     * @param {string} value
     */
    public set $comment(value: string) {
        this.comment = value;
    }

    /**
     * Getter $roomType
     * @return {string}
     */
    public get $roomType(): string {
        return this.roomType;
    }

    /**
     * Setter $roomType
     * @param {string} value
     */
    public set $roomType(value: string) {
        this.roomType = value;
    }

    /**
     * Getter $dateStr
     * @return {string}
     */
    public get $dateStr(): string {
        return this.dateStr;
    }

    /**
     * Setter $dateStr
     * @param {string} value
     */
    public set $dateStr(value: string) {
        this.dateStr = value;
    }

    /**
     * Getter $billCategoryStr
     * @return {string}
     */
    public get $billCategoryStr(): string {
        return this.billCategoryStr;
    }

    /**
     * Setter $billCategoryStr
     * @param {string} value
     */
    public set $billCategoryStr(value: string) {
        this.billCategoryStr = value;
    }
/**
     * Getter $billGroup
     * @return {string}
     */
    public get $billGroup(): string {
        return this.billGroup;
    }

    /**
     * Setter $billGroup
     * @param {string} value
     */
    public set $billGroup(value: string) {
        this.billGroup = value;
    }
    /**
     * Getter $invoiceId
     * @return {number}
     */
    public get $invoiceId(): number {
        return this.invoiceId;
    }

    /**
     * Setter $invoiceId
     * @param {number} value
     */
    public set $invoiceId(value: number) {
        this.invoiceId = value;
    }
    /**
     * Getter $disallowed
     * @return {number}
     */
    public get $disallowed(): number {
        return this.disallowed;
    }

    /**
     * Setter $disallowed
     * @param {number} value
     */
    public set $disallowed(value: number) {
        this.disallowed = value;
    }
    

    /**
     * Getter $invoiceFrom
     * @return {string}
     */
    public get $invoiceFrom(): string {
        return this.invoiceFrom;
    }

    /**
     * Getter $billingCode
     * @return {string}
     */
    public get $billingCode(): string {
        return this.billingCode;
    }

    /**
     * Getter $description
     * @return {string}
     */
    public get $description(): string {
        return this.description;
    }

    /**
     * Getter $quantity
     * @return {number}
     */
    public get $quantity(): number {
        return this.quantity;
    }

    /**
     * Getter $tariff
     * @return {number}
     */
    public get $tariff(): number {
        return this.tariff;
    }

    /**
     * Getter $rate
     * @return {number}
     */
    public get $rate(): number {
        return this.rate;
    }
/**
     * Getter $rate
     * @return {number}
     */
    public get $displayRate(): number {
        return this.displayRate;
    }
    /**
     * Getter $discount
     * @return {number}
     */
    public get $discount(): number {
        return this.discount;
    }

    /**
     * Getter $amount
     * @return {number}
     */
    public get $amount(): number {
        return this.amount;
    }
/**
     * Getter $approvedAmount
     * @return {number}
     */
    public get $approvedAmount(): number {
        return this.approvedAmount;
    }

    /**
     * Getter $isClaimable
     * @return {boolean}
     */
    public get $isClaimable(): boolean {
        return this.isClaimable;
    }

    /**
     * Setter $invoiceFrom
     * @param {string} value
     */
    public set $invoiceFrom(value: string) {
        this.invoiceFrom = value;
    }

    /**
     * Setter $billingCode
     * @param {string} value
     */
    public set $billingCode(value: string) {
        this.billingCode = value;
    }

    /**
     * Setter $description
     * @param {string} value
     */
    public set $description(value: string) {
        this.description = value;
    }

    /**
     * Setter $quantity
     * @param {number} value
     */
    public set $quantity(value: number) {
        this.quantity = value;
    }

    /**
     * Setter $tariff
     * @param {number} value
     */
    public set $tariff(value: number) {
        this.tariff = value;
    }

    /**
     * Setter $rate
     * @param {number} value
     */
    public set $rate(value: number) {
        this.rate = value;
    }
/**
     * Setter $rate
     * @param {number} value
     */
    public set $displayRate(value: number) {
        this.displayRate = value;
    }
    /**
     * Setter $discount
     * @param {number} value
     */
    public set $discount(value: number) {
        this.discount = value;
    }

    /**
     * Setter $amount
     * @param {number} value
     */
    public set $amount(value: number) {
        this.amount = value;
    }

    /**
     * Setter $approvedAmount
     * @param {number} value
     */
    public set $approvedAmount(value: number) {
        this.approvedAmount = value;
    }
    /**
     * Setter $isClaimable
     * @param {boolean} value
     */
    public set $isClaimable(value: boolean) {
        this.isClaimable = value;
    }

    /**
     * Getter $billCategory
     * @return {string}
     */
    public get $billCategory(): string {
        return this.billCategory;
    }

    /**
     * Setter $billCategory
     * @param {string} value
     */
    public set $billCategory(value: string) {
        this.billCategory = value;
    }

    /**
     * Getter $date
     * @return {Date}
     */
    public get $date(): Date {
        return this.date;
    }

    /**
     * Setter $date
     * @param {Date} value
     */
    public set $date(value: Date) {
        this.date = value;
    }

    /**
     * Getter $comments
     * @return {string[]}
     */
    public get $comments(): string[] {
        return this.comments;
    }

    /**
     * Setter $comments
     * @param {string[]} value
     */
    public set $comments(value: string[]) {
        this.comments = value;
    }

    /**
     * Getter $remarks
     * @return {string[]}
     */
    public get $remarks(): string[] {
        return this.remarks;
    }

    /**
     * Setter $remarks
     * @param {string[]} value
     */
    public set $remarks(value: string[]) {
        this.remarks = value;
    }

    /**
     * Getter $category
     * @return {string}
     */
	public get $category(): string {
		return this.category;
	}

    /**
     * Setter $category
     * @param {string} value
     */
	public set $category(value: string) {
		this.category = value;
	}

    /**
     * Getter $group
     * @return {string}
     */
	public get $group(): string {
		return this.group;
	}

    /**
     * Setter $group
     * @param {string} value
     */
	public set $group(value: string) {
		this.group = value;
	}

    /**
     * Getter $type
     * @return {string}
     */
	public get $type(): string {
		return this.type;
	}

    /**
     * Setter $type
     * @param {string} value
     */
	public set $type(value: string) {
		this.type = value;
	}
    /**
     * Getter $icdRegex
     * @return {string}
     */
	public get $icdRegex(): string {
		return this.icdRegex;
	}

    /**
     * Setter $icdRegex
     * @param {string} value
     */
	public set $icdRegex(value: string) {
		this.icdRegex = value;
	}

    /**
     * Getter $pcsRegex
     * @return {string}
     */
	public get $pcsRegex(): string {
		return this.pcsRegex;
	}

    /**
     * Setter $pcsRegex
     * @param {string} value
     */
	public set $pcsRegex(value: string) {
		this.pcsRegex = value;
    }
    
    /**
     * Getter $icdCode
     * @return {string[]}
     */
	public get $icdCode(): string[] {
		return this.icdCode;
	}

    /**
     * Setter $icdCode
     * @param {string[]} value
     */
	public set $icdCode(value: string[]) {
		this.icdCode = value;
	}
 /**
     * Getter $pcsCode
     * @return {string[]}
     */
	public get $pcsCode(): string[] {
		return this.pcsCode;
	}

    /**
     * Setter $icdCode
     * @param {string[]} value
     */
	public set $pcsCode(value: string[]) {
		this.pcsCode = value;
    }
    

    public get $totalTariffDeduction(): number {
        return this.totalTariffDeduction;
    }
    public set $totalTariffDeduction(value: number) {
        this.totalTariffDeduction = value;
    }
    public get $applicableAmount(): number {
        return this.applicableAmount;
    }
    public set $applicableAmount(value: number) {
        this.applicableAmount = value;
    }
}
